import {getRequest, postRequest} from "../fetchWrapper";

/**
 * Récupération de la liste des mois de facturation.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getBillingMonthList = (token) => {
    const url = `/api-v1/admin/billing/month/list`;
    return getRequest(url, token)
}

/**
 * Récupération de la liste des mois de facturation.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getBillingLastMonthList = (token) => {
    const url = `/api-v1/admin/billing/month/last/list`;
    return getRequest(url, token)
}

/**
 * Récupération de la liste des mois de facturation.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getBillsByMonthList = (token, id) => {
    const url = `/api-v1/admin/billing/month/${id}/list`;
    return getRequest(url, token)
}

/**
 * Récupération d'une facture détaillée.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getBillingInfos = (token, id) => {
    const url = `/api-v1/admin/billing/${id}/detail`;
    return getRequest(url, token)
}

/**
 * Mise à jour des informations d'une facture.
 *
 * @param str token Jeton d'authentification.
 * @param object body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateBillingInfosForm = (token, body) => {
    const url = `/api-v1/admin/billing/detail/update`
    return postRequest(url, body, token)
}

/**
 * Impression d'une facture.
 *
 * @param str token Jeton d'authentification.
 * @param int id Identifiant de la facture.
 */
export const printBilling = (token, id) => {
    const url = `/api-v1/admin/billing/flaterate/${id}/print`
    return getRequest(url, token)
}

/**
 * Email d'une facture.
 *
 * @param str token Jeton d'authentification.
 * @param int id Identifiant de la facture.
 */
export const billEmail = (token, id) => {
    const url = `/api-v1/admin/billing/flaterate/bill/email`
    return postRequest(url, id, token)
}

/**
 * Création d'une facturation.
 *
 * @param str token Jeton d'authentification.
 */
export const postBilling = (token, body) => {
    const url = `/api-v1/admin/billing/flaterate/post`
    return postRequest(url, body, token)
}

/**
 * Recherche de facturation.
 *
 * @param str token Jeton d'authentification.
 * @param object body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getBillingBySearch = (token, body) => {
    const url = `/api-v1/admin/billing/search`
    return postRequest(url, body, token);
}

/**
 * Impression d'un mois de facturation.
 *
 * @param str token Jeton d'authentification.
 * @param object body Corps de la requête.
 *
 * @returns Response | null Réponse de la requête à l'API.
 */
export const printBillingMonth = (token, body) => {
    const url = `/api-v1/admin/billing/month/print`
    return postRequest(url, body, token);
}

/**
 * Mail d'un mois de facturation.
 *
 * @param str token Jeton d'authentification.
 * @param object body Corps de la requête.
 *
 * @returns Response | null Réponse de la requête à l'API.
 */
export const mailBillingMonth = (token, body) => {
    const url = `/api-v1/admin/billing/month/mail`
    return postRequest(url, body, token);
}

/**
 * Lecture des paramètres de facturation.
 *
 * @param str token Jeton d'authentification.
 */
export const getBillingSettings = (token) => {
    const url = `/api-v1/admin/billing/settings`
    return getRequest(url, token)
};

/**
 * Mise à jour des paramètres de facturation.
 *
 * @param str token Jeton d'authentification.
 * @param object body Corps de la requête.
 */
export const updateBillingSettings = (token, body) => {
    const url = `/api-v1/admin/billing/settings/update`
    return postRequest(url, body, token)
};

/**
 * Récupération des lignes de facturation personnalisées.
 *
 * @param str token Jeton d'authentification.
 * @param int id Identifiant de la facture.
 */
export const getCustomLineList = (token, id) => {
    const url = `/api-v1/admin/billing/${id}/custom/list`
    return getRequest(url, token)
};

/**
 * Création ou mise à jour d'une ligne de facturation personnalisée.
 *
 * @param str token Jeton d'authentification.
 * @param object body Corps de la requête.
 *
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateCustomLine = (token, body) => {
    const url = `/api-v1/admin/billing/custom/update`
    return postRequest(url, body, token)
};

/**
 * Suppression d'une ligne de facture personnalisée.
 *
 * @param str token Jeton d'authentification.
 * @param object body Corps de la requête.
 *
 * @returns Response | null Réponse de la requête.
 */
export const deleteCustomLine = (token, body) => {
    const url = 'api-v1/admin/billing/custom/delete'
    return postRequest(url, body, token)
};